const STORAGE_VALUE = '1'
const STORAGE_PREFIX = 'smsReminder.editEventTzMismatch:'

/** localStorage key: `<calendar_id>:<display_timezone>:<effective_timezone>` after prefix. */
export function buildEditEventTimezoneMismatchDismissStorageKey(
  calendarId: string,
  displayTimezone: string,
  effectiveTimezone: string,
): string {
  return `${STORAGE_PREFIX}${calendarId}:${displayTimezone}:${effectiveTimezone}`
}

export function isEditEventTimezoneMismatchDismissed(storageKey: string): boolean {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem(storageKey) === STORAGE_VALUE
  } catch {
    return false
  }
}

export function setEditEventTimezoneMismatchDismissed(storageKey: string): void {
  try {
    localStorage.setItem(storageKey, STORAGE_VALUE)
  } catch {
    // ignore quota or private mode
  }
}
